import React from 'react';
import PropTypes from 'prop-types';

const ActionRequiredPage = ({ message = 'Thank You!', subMessage = '' }) => (
    <div className="max-w-4xl mx-auto w-full px-2 py-4 mt-6 mb-6">
        <div
            className={
                'text-center px-4 sm:px-10 bg-green-100 w-5/6 mx-auto rounded'
            }
            data-testid="action-required-message"
        >
            <div className="pt-10 pb-4 text-green-700 text-2xl font-semibold">
                {message}
            </div>
            <div className="pb-10">{subMessage}</div>
        </div>
    </div>
);

ActionRequiredPage.propTypes = {
    message: PropTypes.string,
    subMessage: PropTypes.object,
};

const GenericMessagePage = ({ message = 'Thank You', subMessage = '' }) => (
    <div className="max-w-4xl mx-auto w-full px-2 py-4 mt-6 mb-6">
        <div
            className={
                'text-center px-4 sm:px-10 bg-green-100 w-5/6 mx-auto rounded'
            }
            data-testid="generic-message-page"
        >
            <div className="pt-10 pb-4 text-green-700 text-2xl font-semibold">
                {message}
            </div>
            <div className="pb-10">{subMessage}</div>
        </div>
    </div>
);

GenericMessagePage.propTypes = {
    message: PropTypes.string,
    subMessage: PropTypes.object,
};

export { GenericMessagePage, ActionRequiredPage };
